export const BOLTIC_API_HOST = 'apiv2-streams.fcz0.de/streams/v2'
